import { usePlanLongStayParams as useLongStayParams } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/long-stay-params/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanLongStayParams = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { longStayParams } = viewModel;

	return useLongStayParams({ onSetViewModel, longStayParams });
};
